export default "__VITE_ASSET__aPmARAeN__"